import { RouteRecordRaw } from 'vue-router';
import PageRender from '@/shared/content/PageRender.vue';

export const ContentRoute: RouteRecordRaw = {
    path: '/:catchAll(.*)', // All non-client side routes we assume first to be a content route
    name: 'content',
    component: PageRender,
    meta: {
        isContent: true,
        isPublic: true,
    },
};
